import citron from "../../../image/desserts/citron.webp";
import hipHop from "../../../image/desserts/hipHop.webp";
import Mishel from "../../../image/desserts/Mishel.webp";
import tropicana from "../../../image/desserts/tropicana.webp";

export const imageDesserts = {
    citron:citron,
    hipHop:hipHop,
    Mishel:Mishel,
    tropicana:tropicana,
}